import { GET_STUDENT_DATA } from "../actions/StudentActions";

const initialState = {// initialize states
    StudentDashboardData: [],
};

const StudentReducer = function (state = initialState, action) {
    switch (action.type) {
      case GET_STUDENT_DATA: {// save student data into state
        return { ...state, StudentDashboardData: (action.payload)?action.payload:[] };
      }
      default: {
        return {
          ...state,
        };
      }
    }
  };
  
  export default StudentReducer;